module.exports = __webpack_public_path__ + "static/img/Bitmap_2.ecaf03f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Bitmap_2.jpg
// module id = kfLe
// module chunks = 7